const state = {
  appColors: {},
}

const mutations = {

  SET_APP_COLORS: (state, val) => {
    state.appColors = val
  },
}

const actions = {

  setAppColors ({ commit }, val) {
    commit('SET_APP_COLORS', val)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
